import { Box, Flex, HStack, Image, Link, Text, VStack } from '@chakra-ui/react'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import React, { useContext } from 'react'
import Lottie from 'react-lottie-player'

import assessmentLottie from '../../../animations/assessment_lottie.json'
import proctoringsvg from '../../../assets/svgIcons/proctoring.svg'
import questionsvg from '../../../assets/svgIcons/question.svg'
import { dashedBorder } from '../../../chakraTheme'
import PROCTORING_TYPE_CONFIG from '../../../config/proctoringType'
import { AuthContext } from '../../../contexts/AuthContext'
import loadingsvg from '../../../deprecated/Admission/Dashboard/assets/hour-glass.svg'
import { formatDuration } from '../../../utils/assessment'
import { Profile } from '../../Icons/default'

const Info = React.memo(({ assessment }) => {
    const { kalviumKc } = useContext(AuthContext)
    const spaceBetween = 'space-between'

    dayjs.extend(duration)

    const email = kalviumKc?.getParsedToken()?.preferred_username || ''

    const LogoSection = () => (
        <Flex
            my={12}
            px={16}
            gap={'6'}
            justifyContent={'center'}
            alignItems={'center'}
        >
            <Image
                src="/images/logo_min.svg"
                alt="Logo"
                height={'32px'}
                width={'32px'}
            />
            <Text
                align={'center'}
                fontFamily={'Rubik'}
                fontSize={'32px'}
                fontWeight={'700'}
                width={'376px'}
            >
                Take an Assessment
            </Text>
        </Flex>
    )

    const Detail = ({ name, value, src, ...props }) => {
        return (
            <Flex gap="4" alignItems={'flex-start'} {...props}>
                <Image src={src} mt={'1'} />
                <Flex flexDirection={'column'}>
                    <Text fontSize={'12px'}>{name}</Text>
                    <Text
                        fontWeight={'700'}
                        fontFamily={'Rubik'}
                        fontSize={'14px'}
                    >
                        {value}
                    </Text>
                </Flex>
            </Flex>
        )
    }

    const InfoSection = () => {
        return (
            <Flex
                flexDirection={'column'}
                width={'432px'}
                mx={'16'}
                border={dashedBorder}
            >
                {/* Asessment title */}
                <Box my={'6'} mx={'8'}>
                    <Text
                        fontSize={'18px'}
                        fontWeight={'700'}
                        fontFamily={'Rubik'}
                    >
                        {assessment?.title || 'Assessment'}
                    </Text>
                </Box>

                {/* Assessment Info */}
                <Box as="hr" border="none" borderTop={dashedBorder} />
                <Flex
                    justify={spaceBetween}
                    align={'baseline'}
                    maxW={'400px'}
                    flexDirection={{ base: 'column', tablet: 'row' }}
                    marginX={'8'}
                    marginY={'6'}
                >
                    <VStack align={'baseline'} gap={'6'}>
                        <Detail
                            name={'Proctoring'}
                            value={
                                PROCTORING_TYPE_CONFIG[assessment.proctoring]
                                    ?.title
                            }
                            src={proctoringsvg}
                        />
                        <Detail
                            name={'Total Questions'}
                            value={assessment.questions_count}
                            src={questionsvg}
                        />
                    </VStack>
                    <VStack>
                        <Detail
                            name={'Max. Duration'}
                            value={formatDuration(assessment.duration)}
                            src={loadingsvg}
                        />
                    </VStack>
                </Flex>
            </Flex>
        )
    }

    const Illustration = () => {
        return (
            <Flex maxWidth="432px" justifyContent="center">
                <Lottie loop animationData={assessmentLottie} play={true} />
            </Flex>
        )
    }

    const LoginInfoSection = () =>
        email && (
            <HStack mt={'24px'} width={'108'} gap={'3'}>
                <Box height={'12'} width={'12'}>
                    <Profile height={8} width={8} />
                </Box>
                <Flex flexDirection={'column'}>
                    <Text
                        fontFamily={'Rubik'}
                        fontSize={'16px'}
                        fontWeight={'700'}
                    >
                        Hi {kalviumKc?.getParsedToken()?.given_name}
                    </Text>
                    <Flex gap={'6'}>
                        <Text fontSize={'sm'}>
                            Logged in as{' '}
                            <Text
                                as={'span'}
                                fontWeight={'700'}
                                color={'scorpion2'}
                            >
                                {email}
                            </Text>
                        </Text>
                        <Link
                            textDecoration={'underline'}
                            onClick={() => kalviumKc.doLogout()}
                        >
                            <Text fontWeight={'700'} color={'scorpion2'}>
                                Logout
                            </Text>
                        </Link>
                    </Flex>
                </Flex>
            </HStack>
        )

    const LoginIllustration = () => {
        return (
            <Box ml={'21px !important'}>
                <Image src="/images/ax_login_img.svg" />
            </Box>
        )
    }

    return (
        <VStack
            height={'full'}
            backgroundColor={'oldlace'}
            align={'baseline'}
            justify={spaceBetween}
            borderRight={'3px solid #333333'}
        >
            <LogoSection />
            {kalviumKc.isLoggedIn() ? (
                <VStack
                    align={'baseline'}
                    justify={spaceBetween}
                    height={'full'}
                    width={'full'}
                >
                    {/* container for actual assessment info */}
                    <InfoSection />

                    {/* Login email info and logout action */}
                    <Flex flexDirection={'column'} mt={'8'} mb={'4'} mx={'16'}>
                        <Illustration />
                        <Box border="1px solid #333" />
                        <LoginInfoSection />
                    </Flex>
                </VStack>
            ) : (
                <LoginIllustration />
            )}
        </VStack>
    )
})

Info.displayName = 'Info'
export default Info
